import React from 'react';
import { Box } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { MUIStyledCommonProps } from '@mui/system';


type Props = {
} & MUIStyledCommonProps<Theme> & React.HTMLAttributes<HTMLDivElement>;

const IMBottomButtonsContainer = ({ children, ...rest }: Props) => {
	return (
		<Box sx={{
			position: 'absolute',
			bottom: '26px',
			left: 0,
			right: 0,
			height: '48px',
			zIndex: 1,
			display: 'flex',
			gap: '8px',
			paddingX: '12px',
			'& > *': { width: '100%' },
		}}>
			{children}
		</Box>
	);
};

export default IMBottomButtonsContainer;
